import { useQuery } from '@tanstack/react-query';
import defaultFetch from 'react/api/sagas/fetch/defaultFetch';

async function getRoutePhotosAlbums({ routeId, stopId, entity }) {
  const url = '/PhotoAlbum/Find';

  const payload = {};

  if (routeId && entity === 'route') {
    payload.routes = [
      {
        id: routeId
      }
    ];
  }

  if (stopId && entity === 'stop') {
    payload.stops = [
      {
        id: stopId
      }
    ];
  }

  const response = await defaultFetch(url, payload, 'POST');

  if (response.error) {
    throw new Error('Failed fetch');
  }

  const responseAlbumsList = await Promise.allSettled(
    response.map((album) => {
      const { photoAlbum } = album;
      const urlAlbum = `/PhotoAlbum/${photoAlbum.id}/ListPhotos?thumbnailSize=SMALL`;
      return defaultFetch(urlAlbum);
    })
  );

  responseAlbumsList.forEach((responseAlbum) => {
    if (responseAlbum.status === 'fulfilled') {
      const {
        value: {
          id: albumId, photos, user, creationDate
        }
      } = responseAlbum;
      const responseAlbumIndex = response.findIndex((album) => album.photoAlbum.id === albumId);

      if (responseAlbumIndex >= 0) {
        response[responseAlbumIndex].photoAlbum.photos = photos;
        response[responseAlbumIndex].photoAlbum.user = user;
        response[responseAlbumIndex].photoAlbum.creationDate = creationDate;
      }
    }
  });

  return response;
}

export const getQueryKey = ({ routeId, stopId, entity }) => [
  'route-photos-albums',
  entity,
  routeId,
  stopId
];

export function useRoutePhotosAlbums(payload) {
  return useQuery({
    queryKey: getQueryKey(payload),
    queryFn: () => getRoutePhotosAlbums(payload),
    staleTime: 5 * 60 * 1000, // 5 min
    retry: 2,
    enabled: false
  });
}
